import * as React from 'react';
import {Company} from "../../store/common-values/commonTypes";
import LinkWithDetails from "./LinkWithDetails";
import {DialogActions, DialogContent, DialogTitle} from "@mui/material";

export interface CompanyInfoProps {
    company: Company;
}

export default function (props: CompanyInfoProps) {
    const {company} = props;

    return (
        <React.Fragment>
            <LinkWithDetails text={company?.name} title={"Firma Detaljer"}>
                <DialogContent>
                    <div className="col-sm-12 mb-3">
                        <div>
                            <span className="label">Navn:</span>
                        </div>
                        <div>
                            <span className="data-value">{company.name || 'Ikke spesifisert'}</span>
                        </div>
                    </div>
                    <div className="col-sm-12 mb-3">
                        <div>
                            <span className="label">E-post:</span>
                        </div>
                        <div>
                            <span className="data-value">{company.email ? <a href={`mailto:${company.email}`}>{company.email}</a> : 'Ikke spesifisert'}</span>
                        </div>
                    </div>
                    <div className="col-sm-12 mb-3">
                        <div>
                            <span className="label">Telefon:</span>
                        </div>
                        <div>
                            <span className="data-value">{company.phone ? <a href={`tel:${company.phone}`}>{company.phone}</a> : 'Ikke spesifisert'}</span>
                        </div>
                    </div>
                    <div className="col-sm-12 mb-3">
                        <div>
                            <span className="label">Adresse:</span>
                        </div>
                        <div>
                            <span className="data-value">{[
                                company.addressStreet,
                                company.addressCity,
                                company.addressPostCode,
                                company.addressCountry
                            ]
                                .filter(Boolean)
                                .join(', ') || 'Ikke spesifisert'}</span>
                        </div>
                    </div>
                </DialogContent>
            </LinkWithDetails>
        </React.Fragment>
    );
}
